import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

/**
 * Timeline do turno: o que o assistente já consultou.
 *
 * Um turno agêntico pode levar dezenas de segundos consultando painel,
 * registro e documentação. Sem mostrar o caminho, a espera parece travamento —
 * e o usuário perde a única pista de procedência que ele tem dos números.
 */
export default function AssistantTurnTimeline({ steps = [], running = false }) {
  if (!steps.length && !running) return null;

  const visiveis = steps.slice(-6);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25, py: 0.5 }}>
      {visiveis.map((step, idx) => {
        const ultimo = idx === visiveis.length - 1;
        const erro = !!step.error || step.ok === false;
        const emAndamento = running && ultimo && !erro;

        return (
          <Box
            key={`${step.label}-${idx}`}
            sx={{ display: "flex", alignItems: "center", gap: 0.75, color: "text.secondary" }}
          >
            {emAndamento ? (
              <CircularProgress size={12} />
            ) : erro ? (
              <ErrorOutlineIcon sx={{ fontSize: 14 }} color="warning" />
            ) : (
              <CheckIcon sx={{ fontSize: 14 }} color="success" />
            )}
            <Typography variant="caption" sx={{ opacity: emAndamento ? 1 : 0.75 }}>
              {step.label}
            </Typography>
            {Number(step.durationMs) > 0 && !emAndamento ? (
              <Typography variant="caption" sx={{ opacity: 0.5 }}>
                {`${(Number(step.durationMs) / 1000).toFixed(1)}s`}
              </Typography>
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
}
